// simpaisaApi.js

// Function to initiate a transaction
import { createClient } from '@supabase/supabase-js';
import { getUserKey } from './userKeyGenerator.js';

// export async function initiateTransaction({ name, email, phoneNumber, walletType }) {
//     console.log("Data recieved", name,email,phoneNumber,walletType)
//   try {
//     // const response = await fetch(, {
//     //   method: 'POST',
//     //   headers: {
//     //     'Content-Type': 'application/json',
//     //   },
//     //   body: JSON.stringify({ name, email, phoneNumber, walletType }),
//     // });
// const response = await checkoutApi({ name, email, phoneNumber, walletType });
//     console.log(response);
//     if (!response.ok) {
//       const errorData = await response.json();
//       return ({message:errorData.message || 'Failed to initiate transaction',success:false});
//     }
//
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error('Error initiating transaction:', error);
//     throw error;
//   }
// }

export async function initiateTransaction({
  name,
  email,
  phoneNumber,
  walletType,
}) {
  const reqId = genReqId();
  console.log('Data received:', { name, email, phoneNumber, walletType, reqId });
  await logToRequestLogs({
    reqId,
    event: 'initiateTransaction.start',
    meta: { name, email, phoneNumber, walletType },
  });

  try {
    const result = await checkoutApi({ name, email, phoneNumber, walletType });
    console.log('Transaction Result:', result);
    await logToRequestLogs({
      reqId,
      event: 'initiateTransaction.result',
      meta: result,
    });

    if (!result.success) {
      return { success: false, message: result.message };
    }

    return { success: true, data: result };
  } catch (error) {
    console.error('Error initiating transaction:', error);
    await logToRequestLogs({
      reqId,
      event: 'initiateTransaction.exception',
      meta: { error: String(error?.message || error) },
    });
    return { success: false, message: 'Failed to initiate transaction' };
  }
}

// export async function initiateSafepay({name, email, phoneNumber, walletType,}) {
//   try {
//     const msisdn = phoneNumber;
//     const { data, error: findError } = await supabase
//         .from("subscriptions")
//         .select("*")
//         .eq("phone_number", msisdn);
//
//     const { data: data1 } = await supabase.from("subscriptions").select("*");
//     console.log("safepay ====== ", data1);
//
//     if (findError) {
//       console.error("Error finding user:", findError);
//       return { success: false, message: "Failed to fetch user data" };
//     }
//
//     const existingUser = data && data.length > 0 ? data[0] : null;
//
//     if (existingUser) {
//       // Update the selected wallet type if it's different
//       if (existingUser.selectedwallet !== walletType) {
//         const { error: updateError } = await supabase
//             .from("subscriptions")
//             .update({ selectedwallet: walletType })
//             .eq("phone_number", msisdn);
//
//         if (updateError) {
//           console.error("Error updating wallet type:", updateError);
//           return { success: false, message: "Failed to update wallet type" };
//         }
//       }
//     } else {
//       // Create a new record
//       const { error: insertError } = await supabase
//           .from("subscriptions")
//           .insert([
//             {
//               name,
//               email,
//               phone_number: msisdn,
//               selectedwallet: walletType,
//               timestamp: new Date().toISOString(),
//               status: "inactive",
//               recharge_token: null,
//             },
//           ]);
//
//       if (insertError) {
//         console.error("Error creating new user:", insertError);
//         return { success: false, message: "Failed to create new user" };
//       }
//     }
//
//
//     const response = await fetch(
//       "https://checkout.sajawal.school/api/initiateSafepay",
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           customerReference: email, // Replace with dynamic email if needed
//         }),
//       }
//     );
//
//     const initiateSafePayData = await response.json();
//
//     if (response.ok && initiateSafePayData.success) {
//       console.log("Safepay URL:", initiateSafePayData.url); // Debugging log
//       return { status: true, url: initiateSafePayData.url };
//     } else {
//       console.error("Safepay failed:", initiateSafePayData);
//       return { status: false, message: "Failed " };
//     }
//   } catch (err) {
//     return { status: false, message: "Failed " };
//   }
// }

export async function initiateSafepay({
  name,
  email,
  phoneNumber,
  walletType,
}) {
  const reqId = genReqId();
  await logToRequestLogs({
    reqId,
    event: 'initiateSafepay.start',
    meta: { name, email, phoneNumber, walletType },
  });
  try {
    const msisdn = phoneNumber;

    // ✅ Step 1: Insert or update user details in Supabase
    const { data, error: findError } = await supabase
      .from('subscriptions')
      .select('*')
      .eq('phone_number', msisdn);
    await logToRequestLogs({
      reqId,
      event: 'supabase.subscriptions.select',
      meta: {
        msisdn,
        ok: !findError,
        error: findError ? { message: findError.message, code: findError.code, details: findError.details } : null,
        count: Array.isArray(data) ? data.length : null,
      },
    });

    if (findError) {
      console.error('Error finding user:', findError);
      await logToRequestLogs({
        reqId,
        event: 'initiateSafepay.fail',
        meta: { step: 'findUser', error: { message: findError.message, code: findError.code, details: findError.details } },
      });
      return { success: false, message: 'Failed to fetch user data' };
    }

    const existingUser = data && data.length > 0 ? data[0] : null;

    if (existingUser) {
      const { error: updateError } = await supabase
        .from('subscriptions')
        .update({
          selectedwallet: walletType,
          timestamp: new Date().toISOString(),
        })
        .eq('phone_number', msisdn);
      await logToRequestLogs({
        reqId,
        event: 'supabase.subscriptions.update.wallet',
        meta: {
          msisdn,
          walletType,
          ok: !updateError,
          error: updateError ? { message: updateError.message, code: updateError.code, details: updateError.details } : null,
        },
      });

      if (updateError) {
        console.error('Error updating wallet type:', updateError);
        await logToRequestLogs({
          reqId,
          event: 'initiateSafepay.fail',
          meta: { step: 'updateWallet', error: { message: updateError.message, code: updateError.code, details: updateError.details } },
        });
        return { success: false, message: 'Failed to update wallet type' };
      }
    } else {
      const { error: insertError } = await supabase
        .from('subscriptions')
        .insert([
          {
            name,
            email,
            phone_number: msisdn,
            selectedwallet: walletType,
            timestamp: new Date().toISOString(),
            status: 'inactive',
          },
        ]);
      await logToRequestLogs({
        reqId,
        event: 'supabase.subscriptions.insert',
        meta: {
          msisdn,
          walletType,
          ok: !insertError,
          error: insertError ? { message: insertError.message, code: insertError.code, details: insertError.details } : null,
        },
      });

      if (insertError) {
        console.error('Error inserting user:', insertError);
        await logToRequestLogs({
          reqId,
          event: 'initiateSafepay.fail',
          meta: { step: 'insertUser', error: { message: insertError.message, code: insertError.code, details: insertError.details } },
        });
        return { success: false, message: 'Failed to create new user' };
      }
    }

    console.log('User details successfully stored in Supabase!');

    // ✅ Step 2: Call Safepay API
    await logToRequestLogs({
      reqId,
      event: 'safepay.initiate.request',
      meta: { url: '/checkout/api/initiateSafepay', email },
    });
    const response = await fetch(
      '/checkout/api/initiateSafepay',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerReference: email }),
      }
    );

    const initiateSafePayData = await response.json();
    console.log('Safepay Response:', initiateSafePayData);
    await logToRequestLogs({
      reqId,
      event: 'safepay.initiate.response',
      meta: { ok: response.ok, status: response.status, initiateSafePayData },
    });

    if (response.ok && initiateSafePayData.success) {
      await logToRequestLogs({
        reqId,
        event: 'initiateSafepay.success',
        meta: { url: initiateSafePayData.url },
      });
      return { success: true, url: initiateSafePayData.url };
    } else {
      console.error('Safepay failed:', initiateSafePayData);
      await logToRequestLogs({
        reqId,
        event: 'initiateSafepay.fail',
        meta: { step: 'safepay', initiateSafePayData },
      });
      return {
        success: false,
        message: initiateSafePayData.message || 'Failed to initiate Safepay',
      };
    }
  } catch (err) {
    console.error('Error in initiateSafepay:', err);
    await logToRequestLogs({
      reqId,
      event: 'initiateSafepay.exception',
      meta: { error: String(err?.message || err) },
    });
    return { success: false, message: 'Failed to initiate Safepay' };
  }
}
// Function to verify OTP
export async function verifyOTP({ phoneNumber, otp, walletType }) {
  const reqId = genReqId();
  try {
    // const response = await fetch('http://localhost:3001/api/verifyOTP', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({ phoneNumber, otp, walletType }),
    // });

    await logToRequestLogs({
      reqId,
      event: 'verifyOTP.start',
      meta: { phoneNumber, walletType, hasOtp: !!otp },
    });

    const response = await verifyOTPAPI({ phoneNumber, otp, walletType, reqId });
    if (response.success) {
      console.log('OTP verified successfully:', response);
    } else {
      console.error('OTP verification failed:', response.message);
    }

    if (!response.success) {
      const errorData = response.message;
      return {
        message: errorData
          ? errorData.replace(/-/g, ' ')
          : 'Failed to Verify OTP !',
        success: false,
      };
    }

    const data = response;
    await logToRequestLogs({
      reqId,
      event: 'verifyOTP.result',
      meta: data,
    });
    return data;
  } catch (error) {
    console.error('Error verifying OTP:', error);
    await logToRequestLogs({
      reqId,
      event: 'verifyOTP.exception',
      meta: { error: String(error?.message || error) },
    });
    throw error;
  }
}

export async function verifyOTPAPI({ phoneNumber, otp, walletType, reqId }) {
  console.log(
    'Data received for OTP verification:',
    phoneNumber,
    otp,
    walletType
  );

  if (!phoneNumber || !otp || !walletType) {
    throw new Error('Phone number, OTP, and wallet type are required');
  }

  const msisdn = phoneNumber;
  const operatorId = walletType === 'Jazzcash' ? '100008' : '100007'; // Jazzcash or Easypaisa
  const userKey = await getUserKey(msisdn);

  const payload = {
    merchantId: '2000841',
    operatorId,
    transactionType: '9',
    productId: '1958', // Adjust productId as per environment
    // productId: "1958",
    msisdn,
    productReference: 'Shaikh Sajawal School Monthly Subscription',
    userKey,
    otp,
  };

  try {
    await logToRequestLogs({
      reqId: reqId || genReqId(),
      event: 'simpaisa.verify.request',
      meta: { url: 'https://api.sajawal.school/v2/wallets/transaction/verify', payload },
    });
    const response = await fetch(
      'https://api.sajawal.school/v2/wallets/transaction/verify',
      {
        method: 'POST',
        headers: {
          'Accept': 'text/plain, application/json, application/*+json',
          'Content-Type': 'application/json',
          'mode': 'payin',
          'region': 'PK',
          'operatorId': operatorId,
          'version': '3.0',
        },
        body: JSON.stringify(payload),
      }
    );

    console.log('OTP verification response:', response);

    // const data1 = await response.json();
    // console.log("After Parse :", data1);

    if (!response.ok) {
      const errorData = await response.json();
      await logToRequestLogs({
        reqId: reqId || genReqId(),
        event: 'simpaisa.verify.response',
        meta: { ok: false, status: response.status, errorData },
      });
      return {
        message: errorData.message || 'Failed to verify OTP',
        success: false,
      };
    }

    const data = await response.json();
    await logToRequestLogs({
      reqId: reqId || genReqId(),
      event: 'simpaisa.verify.response',
      meta: { ok: true, status: response.status, data },
    });
    if (data.status === '0000') {
      // OTP verified successfully - now fetch sourceId via inquiry endpoint
      let sourceId = data?.sourceId;
      if (!sourceId && data?.transactionId) {
        await logToRequestLogs({
          reqId: reqId || genReqId(),
          event: 'verifyOTP.sourceId.missing.inquiring',
          meta: { transactionId: data.transactionId, msisdn },
        });
        const inquiryResult = await inquireTransaction(data.transactionId);
        if (inquiryResult.success && inquiryResult.sourceId) {
          sourceId = inquiryResult.sourceId;
          await logToRequestLogs({
            reqId: reqId || genReqId(),
            event: 'verifyOTP.sourceId.recovered',
            meta: { sourceId, transactionId: data.transactionId },
          });
        } else {
          await logToRequestLogs({
            reqId: reqId || genReqId(),
            event: 'verifyOTP.sourceId.inquiry.failed',
            meta: { transactionId: data.transactionId, inquiryResult },
          });
        }
      }

      // Update subscription with sourceId if we have it
      if (sourceId) {
        const { error: updateError } = await supabase
          .from('subscriptions')
          .update({ sourceid: sourceId, status: 'active', last_charged: new Date().toISOString() })
          .eq('phone_number', msisdn);

        await logToRequestLogs({
          reqId: reqId || genReqId(),
          event: 'supabase.subscriptions.update.sourceId',
          meta: {
            msisdn,
            sourceId,
            ok: !updateError,
            error: updateError ? { message: updateError.message, code: updateError.code } : null,
          },
        });
      }

      return {
        success: true,
        transactionId: data?.transactionId,
        sourceId,
        message: data?.message,
        ...data,
      };
    } else {
      return {
        success: false,
        transactionId: data?.transactionId,
        message: data?.message,
      };
    }
  } catch (error) {
    console.error('Error during OTP verification:', error);
    await logToRequestLogs({
      reqId: reqId || genReqId(),
      event: 'simpaisa.verify.exception',
      meta: { error: String(error?.message || error) },
    });
    throw new Error('OTP verification failed');
  }
}

// api/initiateTransaction.js

const supabase = createClient(
  'https://omgwcmqastewylltshdu.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9tZ3djbXFhc3Rld3lsbHRzaGR1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzA0Mjc5MzIsImV4cCI6MjA0NjAwMzkzMn0.Dd82cSB_T2fKSQgBW4oQtFtAMFVXC1gkjW78FaVIoF8'
);

function genReqId() {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch {
    // ignore
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function redactSensitive(value) {
  const SENSITIVE_KEYS = new Set([
    'authorization',
    'cookie',
    'set-cookie',
    'api-token',
    'apikey',
    'apiKey',
    'supabaseKey',
    'SUPABASE_KEY',
    'otp',
    'userKey',
    'recharge_token',
  ]);

  const walk = (v) => {
    if (!v || typeof v !== 'object') return v;
    if (Array.isArray(v)) return v.map(walk);
    const out = {};
    for (const [k, val] of Object.entries(v)) {
      if (SENSITIVE_KEYS.has(String(k))) out[k] = '[REDACTED]';
      else out[k] = walk(val);
    }
    return out;
  };

  return walk(value);
}

function safeJson(value, maxLen = 8000) {
  try {
    const s = JSON.stringify(value);
    if (typeof s === 'string' && s.length > maxLen) return `${s.slice(0, maxLen)}...<truncated>`;
    return s;
  } catch {
    return null;
  }
}

async function logToRequestLogs({ reqId, event, meta }) {
  // Best-effort client-side logging. Must never break the payment flow.
  try {
    const source =
      typeof window !== 'undefined' && window?.location
        ? window.location.origin
        : 'client';

    const body = {
      reqId,
      event,
      meta: redactSensitive(meta),
    };

    await supabase.from('request_logs').insert([
      {
        method: `client:${event}`,
        headers: safeJson({
          ua:
            typeof navigator !== 'undefined'
              ? navigator.userAgent
              : undefined,
        }),
        body: safeJson(body),
        source,
        timestamp: new Date().toISOString(),
      },
    ]);
  } catch (e) {
    // Keep a console breadcrumb if Supabase logging is blocked by RLS or network.
    console.warn('request_logs insert failed:', e?.message || e);
  }
}

export async function checkoutApi({ name, email, phoneNumber, walletType }) {
  const reqId = genReqId();
  console.log('Data received:', { name, email, phoneNumber, walletType, reqId });
  await logToRequestLogs({
    reqId,
    event: 'checkoutApi.start',
    meta: { name, email, phoneNumber, walletType },
  });

  const msisdn = phoneNumber;

  // Define operatorId based on the selected wallet type
  const operatorId = walletType === 'Jazzcash' ? '100008' : '100007';

  try {
    // Check if the user exists in the subscriptions table
    const { data, error: findError } = await supabase
      .from('subscriptions')
      .select('*')
      .eq('phone_number', msisdn);
    await logToRequestLogs({
      reqId,
      event: 'supabase.subscriptions.select',
      meta: {
        msisdn,
        ok: !findError,
        error: findError ? { message: findError.message, code: findError.code, details: findError.details } : null,
        count: Array.isArray(data) ? data.length : null,
      },
    });

    if (findError) {
      console.error('Error finding user:', findError);
      await logToRequestLogs({
        reqId,
        event: 'checkoutApi.fail',
        meta: { step: 'findUser', error: { message: findError.message, code: findError.code, details: findError.details } },
      });
      return { success: false, message: 'Failed to fetch user data' };
    }

    const existingUser = data && data.length > 0 ? data[0] : null;

    if (existingUser) {
      // Update the selected wallet type if it's different
      if (existingUser.selectedwallet !== walletType) {
        const { error: updateError } = await supabase
          .from('subscriptions')
          .update({ selectedwallet: walletType })
          .eq('phone_number', msisdn);
        await logToRequestLogs({
          reqId,
          event: 'supabase.subscriptions.update.wallet',
          meta: {
            msisdn,
            walletType,
            ok: !updateError,
            error: updateError ? { message: updateError.message, code: updateError.code, details: updateError.details } : null,
          },
        });

        if (updateError) {
          console.error('Error updating wallet type:', updateError);
          await logToRequestLogs({
            reqId,
            event: 'checkoutApi.fail',
            meta: { step: 'updateWallet', error: { message: updateError.message, code: updateError.code, details: updateError.details } },
          });
          return { success: false, message: 'Failed to update wallet type' };
        }
      }
    } else {
      // Create a new record
      const { error: insertError } = await supabase
        .from('subscriptions')
        .insert([
          {
            name,
            email,
            phone_number: msisdn,
            selectedwallet: walletType,
            timestamp: new Date().toISOString(),
            status: 'inactive',
            recharge_token: null,
          },
        ]);
      await logToRequestLogs({
        reqId,
        event: 'supabase.subscriptions.insert',
        meta: {
          msisdn,
          walletType,
          ok: !insertError,
          error: insertError ? { message: insertError.message, code: insertError.code, details: insertError.details } : null,
        },
      });

      if (insertError) {
        console.error('Error creating new user:', insertError);
        await logToRequestLogs({
          reqId,
          event: 'checkoutApi.fail',
          meta: { step: 'insertUser', error: { message: insertError.message, code: insertError.code, details: insertError.details } },
        });
        return { success: false, message: 'Failed to create new user' };
      }
    }

    // Generate userKey before preparing payload
    const userKey = await getUserKey(msisdn);

    // Prepare the transaction payload
    const payload = {
      merchantId: '2000841',
      operatorId,
      transactionType: '9',
      productId: '1958',
      // productId: "1958",
      msisdn,
      productReference: 'Shaikh Sajawal School Monthly Subscription',
      userKey,
    };

    // Revert back

    // Call the transaction initiation endpoint
    await logToRequestLogs({
      reqId,
      event: 'simpaisa.initiate.request',
      meta: { url: 'https://api.sajawal.school/v2/wallets/transaction/initiate', payload },
    });
    const response = await fetch(
      'https://api.sajawal.school/v2/wallets/transaction/initiate',
      {
        method: 'POST',
        headers: {
          'Accept': 'text/plain, application/json, application/*+json',
          'Content-Type': 'application/json',
          'mode': 'payin',
          'region': 'PK',
          'operatorId': operatorId,
          'version': '3.0',
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      await logToRequestLogs({
        reqId,
        event: 'simpaisa.initiate.response',
        meta: { ok: false, status: response.status, errorData },
      });
      return {
        success: false,
        message: errorData.message || 'Transaction initiation failed',
      };
    }
    console.log('Before parse Simpaisa Response:', response);

    const responseData = await response.json();
    console.log('Simpaisa Response:', responseData);
    await logToRequestLogs({
      reqId,
      event: 'simpaisa.initiate.response',
      meta: { ok: true, status: response.status, responseData },
    });

    if (responseData.status === '0000') {
      await logToRequestLogs({
        reqId,
        event: 'checkoutApi.success',
        meta: { transactionId: responseData.transactionId, message: responseData.message },
      });
      return {
        success: true,
        transactionId: responseData.transactionId,
        message: responseData.message,
      };
    } else {
      await logToRequestLogs({
        reqId,
        event: 'checkoutApi.fail',
        meta: { step: 'simpaisaInitiate', responseData },
      });
      return {
        success: false,
        transactionId: responseData.transactionId,
        message: responseData.message,
      };
    }
  } catch (error) {
    console.error('Error initiating transaction:', error);
    await logToRequestLogs({
      reqId,
      event: 'checkoutApi.exception',
      meta: { error: String(error?.message || error) },
    });
    return { success: false, message: 'An unexpected error occurred' };
  }
}

/**
 * Inquire a transaction from Simpaisa to get sourceId and full transaction details.
 * Use this when sourceId is missing from the initial response.
 * @param {string} transactionId - The transaction ID to inquire about
 * @returns {Promise<{success: boolean, sourceId?: string, transaction?: object, message?: string}>}
 */
export async function inquireTransaction(transactionId) {
  const reqId = genReqId();
  const merchantId = '2000841';

  await logToRequestLogs({
    reqId,
    event: 'inquireTransaction.start',
    meta: { transactionId, merchantId },
  });

  if (!transactionId) {
    await logToRequestLogs({
      reqId,
      event: 'inquireTransaction.fail',
      meta: { error: 'Transaction ID is required' },
    });
    return { success: false, message: 'Transaction ID is required' };
  }

  const payload = {
    merchantId,
    transactionId: String(transactionId),
  };

  try {
    await logToRequestLogs({
      reqId,
      event: 'simpaisa.inquire.request',
      meta: { url: 'https://wallets.simpaisa.com/v2/inquire/wallet/transaction/inquiry', payload },
    });

    const response = await fetch(
      'https://wallets.simpaisa.com/v2/inquire/wallet/transaction/inquiry',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      await logToRequestLogs({
        reqId,
        event: 'simpaisa.inquire.response',
        meta: { ok: false, status: response.status, errorData },
      });
      return {
        success: false,
        message: errorData.message || 'Failed to inquire transaction',
      };
    }

    const data = await response.json();
    await logToRequestLogs({
      reqId,
      event: 'simpaisa.inquire.response',
      meta: { ok: true, status: response.status, data },
    });

    const transaction = data?.transaction;
    if (transaction && transaction.status === '0000') {
      await logToRequestLogs({
        reqId,
        event: 'inquireTransaction.success',
        meta: {
          transactionId: transaction.transactionId,
          sourceId: transaction.sourceId,
          msisdn: transaction.msisdn,
        },
      });
      return {
        success: true,
        sourceId: transaction.sourceId,
        transactionId: transaction.transactionId,
        msisdn: transaction.msisdn,
        operatorId: transaction.operatorId,
        amount: transaction.amount,
        userKey: transaction.userKey,
        createdTimestamp: transaction.createdTimestamp,
        updatedTimestamp: transaction.updatedTimestamp,
        transaction,
        message: transaction.message,
      };
    } else {
      await logToRequestLogs({
        reqId,
        event: 'inquireTransaction.fail',
        meta: { step: 'transactionNotSuccess', data },
      });
      return {
        success: false,
        message: transaction?.message || data?.message || 'Transaction inquiry failed',
        transaction,
      };
    }
  } catch (error) {
    console.error('Error inquiring transaction:', error);
    await logToRequestLogs({
      reqId,
      event: 'inquireTransaction.exception',
      meta: { error: String(error?.message || error) },
    });
    return { success: false, message: 'An unexpected error occurred during inquiry' };
  }
}
